// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationFriendshipResponse_wrapper__BRIa0","link":"NotificationFriendshipResponse_link__KMcYa"};